export default __webpack_public_path__ + "static/home_bodegon_bolivia-56d2c808b8a6dda844f5ab23edbfa827.png";